import React from 'react'
import { Router, hashHistory, Link, browserHistory } from 'react-router'
import config from 'src/core/config'
import Notfound from 'src/component/NotFound'

// import oauth from './oauth'

// 切换浏览器访问模式
// const history = browserHistory
const history = hashHistory

const _import = require('src/helper/import/import.' + process.env.NODE_ENV)   // 引入加载路径 -  /pages/xxx

function errorLoading(cb) {
  return (...arg) => {
    let t = ''
    arg.map((d) => {
      t += `${d}\n`
    })
    console.error(t)
    cb(null, Notfound)
  }
}

function loadRoute(cb) {
  return (module) => cb(null, module.default)
}

/**
 * @description 动态加载路由
 */
function loadComponent() {
  return async function (location, cb) {
    let { module, controller, action } = location.params
    // 默认路径
    module = module || config.route.default.module
    controller = controller || config.route.default.controller
    action = action || config.route.default.action

    try {
      const pagePath = `${module}/${controller}/${action}`
      const componentModule = await _import(pagePath)
      const getComponent = loadRoute(cb)
      getComponent(componentModule)
    } catch (e) {
      errorLoading(cb)
    }
  }
}

const routes = {
  path: '/',
  // component: layout,
  // onEnter: oauth,
  indexRoute: {
    getComponent: loadComponent()
  },
  childRoutes: [
    {
      path: ':module/:controller',
      getComponent: loadComponent()
    },
    // 独立子页面
    {
      path: ':module/:controller/:action',
      getComponent: loadComponent()
    },
    { path: '*', component: Notfound }
  ]
}

const RouteComponent = () => <Router key={new Date()} history={history} routes={routes}></Router>

export { routes, history, Router, Link, RouteComponent }




// WEBPACK FOOTER //
// src/core/router.js